import i18n from "i18next";
import { useTranslation } from "react-i18next";
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
const GlobalCTA = () => {
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  let content = {
    titleEn: 'Ready to Experience the Future of Insurance?',
    titleFr: 'Prêt à faire l\'expérience de l\'assurance de demain ?',
    descEn: 'Get an instant quote online in less than 2 minutes, or speak directly with one of our licensed brokers to build custom commercial or personal protection.',
    descFr: 'Obtenez une soumission en ligne en moins de 2 minutes, ou discutez directement avec un de nos courtiers certifiés pour concevoir une protection sur mesure.',
    secBtnEn: 'Speak with a Broker',
    secBtnFr: 'Parler à un courtier',
    action: 'chat',
    icon: 'rocket_launch'
  };
  if (path.includes('/products/')) {
    content = {
      titleEn: 'Ready to get protected?',
      titleFr: 'Prêt à être protégé ?',
      descEn: 'Get a fast, secure, and accurate quote in minutes, or explore our other comprehensive insurance products.',
      descFr: 'Obtenez une soumission rapide, sécurisée et précise en quelques minutes, ou explorez nos autres produits d\'assurance.',
      secBtnEn: 'Speak with a Broker',
      secBtnFr: 'Parler à un courtier',
      action: 'chat',
      icon: 'shield'
    };
  } else if (path.includes('/faqs') || path.includes('/claims')) {
    content = {
      titleEn: "Need more assistance?",
      titleFr: "Besoin de plus d'aide ?",
      descEn: 'Our licensed brokers are available to answer any questions, or get started immediately with an instant quote.',
      descFr: 'Nos courtiers certifiés sont disponibles pour répondre à toutes vos questions, ou commencez immédiatement avec une soumission.',
      secBtnEn: 'Speak with a Broker',
      secBtnFr: 'Parler à un courtier',
      action: 'chat',
      icon: 'support_agent'
    };
  } else if (path.includes('/blogs')) {
    content = {
      titleEn: 'Stay informed, stay protected',
      titleFr: 'Restez informé, restez protégé',
      descEn: 'Read more of our latest insights and insurance tips, or secure your assets today with an instant quote.',
      descFr: 'Lisez nos derniers conseils en assurance, ou sécurisez vos actifs dès aujourd\'hui avec une soumission instantanée.',
      secBtnEn: 'All Articles',
      secBtnFr: 'Tous les articles',
      secLink: '/blogs',
      icon: 'menu_book'
    };
  } else if (path === '/contact-us' || path === '/join-us' || path === '/partner-with-us' || path.includes('/quote/')) {
    return null; // Do not render a CTA on specific action/funnel pages
  }
  return <section className="max-w-[1440px] mx-auto px-12 my-20">
      <div className="bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#0f172a] text-white p-10 md:p-14 rounded-[2rem] shadow-2xl relative overflow-hidden border border-white/10 text-center">
        <div className="absolute -left-10 -bottom-10 w-72 h-72 bg-primary/10 rounded-full blur-[80px] z-0 pointer-events-none"></div>
        <div className="absolute -right-10 -top-10 w-72 h-72 bg-tertiary/10 rounded-full blur-[80px] z-0 pointer-events-none"></div>
        
        <div className="relative z-10 max-w-3xl mx-auto flex flex-col items-center">
          <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-6 text-primary-fixed">
            <span className="material-symbols-outlined text-2xl">{content.icon}</span>
          </div>
          
          <h2 className="font-headline text-3xl md:text-4xl font-extrabold mb-4">
            <span dangerouslySetInnerHTML={{
            __html: i18n.language?.startsWith("fr") ? content.titleFr : content.titleEn
          }} />
          </h2>
          <p className="font-body text-sm md:text-base text-white/80 mb-8 max-w-2xl leading-relaxed">
            <span dangerouslySetInnerHTML={{
            __html: i18n.language?.startsWith("fr") ? content.descFr : content.descEn
          }} />
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 w-full justify-center sm:max-w-md">
            <button onClick={() => {
            navigate('/products/replacement-insurance/quote');
            window.scrollTo(0, 0);
          }} className="btn-primary w-full py-4 rounded-xl font-bold text-sm text-center shadow-lg border border-primary bg-primary text-white hover:bg-primary/95 transition-all transform hover:-translate-y-1 hover:shadow-[0_0_20px_rgba(var(--primary),0.4)] active:scale-95 cursor-pointer">
              <span dangerouslySetInnerHTML={{
              __html: t("globalcta_span_628")
            }} />
            </button>
            
            <button onClick={() => {
            if (content.action === 'chat') {
              window.dispatchEvent(new CustomEvent('open-floating-help'));
            } else if (content.secLink) {
              navigate(content.secLink);
              window.scrollTo(0, 0);
            }
          }} className="btn-secondary w-full py-4 rounded-xl font-bold text-sm text-center border border-white/20 bg-white/10 text-white hover:bg-white/25 transition-all transform hover:-translate-y-0.5 active:scale-95 cursor-pointer flex items-center justify-center gap-2">
              <span dangerouslySetInnerHTML={{
              __html: i18n.language?.startsWith("fr") ? content.secBtnFr : content.secBtnEn
            }} />
              {content.action === 'chat' && <span className="material-symbols-outlined text-sm">chat</span>}
            </button>
          </div>
        </div>
      </div>
    </section>;
};
export default GlobalCTA;